import { Middleware } from '@nuxt/types'
import {isUserAnAdmin, isUserTrialAdmin} from "~/helper/RoleHelper";

export const isAdmin: Middleware = (context) => {
  // Use context
 if (!isUserAnAdmin(context)) {
    context.redirect('/trials')
  }
}

export const isTrialAdmin: Middleware = (context) => {
  if (!isUserTrialAdmin(context)) {
    context.redirect('/trials')
  }
}

export const isAdminOrTrialAdmin: Middleware = (context) => {
  if (!isUserTrialAdmin(context) && !isUserAnAdmin(context)) {
    context.redirect('/trials')
  }
}


